var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#ACB1B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2011 14.2353L14.8618 15.8706C15.202 16.2049 15.202 16.7477 14.8618 17.0824C14.522 17.417 13.9711 17.417 13.6314 17.0824L11.999 15.4754L10.368 17.0824C10.1978 17.2494 9.97498 17.3332 9.75218 17.3332C9.52972 17.3332 9.30709 17.2494 9.13709 17.0824C8.79727 16.7477 8.79727 16.2053 9.13674 15.8706L10.7973 14.2353C10.1927 14.0997 9.60954 13.8637 9.07253 13.5319C8.66604 13.2796 8.54376 12.7508 8.80008 12.3502C9.05551 11.9491 9.59253 11.8285 9.99972 12.0807C11.2157 12.8339 12.7822 12.8343 13.9988 12.0807C14.406 11.8285 14.943 11.9491 15.1988 12.3502C15.4549 12.7505 15.3325 13.2796 14.926 13.5319C14.389 13.8641 13.8058 14.0997 13.2011 14.2353ZM11.9994 11.8494C10.3613 11.8494 9.02902 10.5378 9.02902 8.92529C9.02902 7.31209 10.3613 6 11.9994 6C13.6378 6 14.9697 7.31209 14.9697 8.92529C14.9697 10.5378 13.6378 11.8494 11.9994 11.8494ZM11.9994 7.71427C11.3218 7.71427 10.7695 8.25742 10.7695 8.92529C10.7695 9.59248 11.3218 10.1358 11.9994 10.1358C12.6776 10.1358 13.2292 9.59248 13.2292 8.92529C13.2292 8.25742 12.6776 7.71427 11.9994 7.71427Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.55974b897c4c25c0fafaa533701e70c8.svg";
export { ForwardRef as ReactComponent };